// extracted by mini-css-extract-plugin
export default {"routerLink":"src-state-router-links-routerLinks__routerLink--GLAbt"};